module.exports = __webpack_public_path__ + "static/media/11x17no1.89ff5200.jpg";